import firebase from "../../src/config/firebase";
require("firebase/auth");
const invoiceService = {
    async getInvoices() {
        return firebase.firestore().collection("invoices").get();
    },
    async getInvoice(id) {
        return firebase.firestore().collection("invoices").doc(id).get();
    },
    async saveInvoice(data) {
        console.log("salvando invoice ");

        firebase
            .firestore()
            .collection("invoices")
            .add(data)
            .catch((error) => {
                console.log(error);
            });
    },
    async updateInvoice(id, newData) {
        firebase
            .firestore()
            .collection("invoices")
            .doc(id)
            .update(newData)
            .catch((error) => {
                console.log(error);
            });
    },
    async updateInvoiceByXmlID(xmlID, newData) {
        console.log("Atualizando fatura pelo xmlID");
        try {
            // Consulta para encontrar o documento com base no xmlID
            const querySnapshot = await firebase
                .firestore()
                .collection("invoices")
                .where("xmlID", "==", xmlID)
                .get();

            // Verifica se há algum documento correspondente
            if (querySnapshot.docs.length > 0) {
                const docRef = querySnapshot.docs[0].ref;

                // Atualiza o documento encontrado
                await docRef.update(newData);

                console.log("Documento atualizado com sucesso");
            } else {
                console.log("Nenhum documento encontrado com o xmlID fornecido");
            }
        } catch (error) {
            console.error("Erro ao atualizar o documento:", error);
            throw error; // Propaga o erro para tratamento posterior, se necessário
        }
    },
    async deleteInvoice(id) {
        try {
            console.log("Excluindo invoice");
            const docRef = firebase.firestore().collection("invoices").doc(id);
            await docRef.delete();
            console.log("Invoice excluído com sucesso!");
        } catch (error) {
            console.error("Erro ao excluir invoice: ", error);
        }
    },



/**
 * Busca notas de fretes de acordo com o ID do embarcador (ou IDs de embarcadores
 * afiliados ao usuário) e retorna o resultado em forma de um objeto que "imita" o
 * snapshot do Firebase para o frontend não quebrar.
 * 
 * @param {string} idShipperAtual - ID do embarcador atual
 * @param {string} userId - ID do usuário (opcional)
 * @returns {object} - um objeto que contém as notas de fretes encontradas
 * @returns {object.docs} - um array de objetos que representam as notas de fretes
 * @returns {object.docs.data()} - uma função que retorna os dados da nota de fretes
 * @returns {object.empty} - um booleano que indica se o resultado está vazio
 */
    async getInvoicesByShipper(idShipperAtual, userId) {
        console.log("------------------------------------------");
        console.log("INICIANDO BUSCA DE NOTAS (COM SUPORTE A MUITOS DADOS)");

        try {
            const db = firebase.firestore();
            let listaDeEmbarcadores = [idShipperAtual];

            // 1. Busca permissões do usuário
            if (userId) {
                const querySnapshot = await db.collection("user_web").where("uid", "==", userId).get();

                if (!querySnapshot.empty) {
                    const userData = querySnapshot.docs[0].data();;

                    if (userData.viewALL) {
                        console.log("Usuário tem permissão viewALL (Admin)");


                        return firebase.firestore().collection("invoices").get();

                    }

                    if (userData.uidShipperAffiliates && Array.isArray(userData.uidShipperAffiliates)) {
                        const affiliateUids = userData.uidShipperAffiliates;
                        console.log("Afiliados encontrados: ", affiliateUids);

                        // Junta o atual com os afiliados
                        listaDeEmbarcadores = [...listaDeEmbarcadores, ...affiliateUids];
                    }
                }
            }

            // Remove duplicatas
            const embarcadoresUnicos = Array.from(new Set(listaDeEmbarcadores));
            console.log(`Buscando notas de ${embarcadoresUnicos.length} embarcadores...`);

            // ==================================================================
            //  Buscar XMLs (Usando Chunking para vencer o limite )
            // ==================================================================

            // Cria cópia do array para não afetar o original no splice
            const shippersParaProcessar = [...embarcadoresUnicos];
            const chunksDeEmbarcadores = chunkArray(shippersParaProcessar, 30);

            let invoicesKeys = [];

            // Executa várias promessas (consultas) ao mesmo tempo
            await Promise.all(
                chunksDeEmbarcadores.map(async (lote) => {
                    const snapshot = await db
                        .collection("xml_document_nfe")
                        .where("uidShipper", "in", lote)
                        .get();

                    snapshot.forEach((doc) => invoicesKeys.push(doc.id));
                })
            );

            console.log(`Encontrados ${invoicesKeys.length} XMLs vinculados.`);

            if (invoicesKeys.length === 0) {
                return { docs: [] };
            }

            // Remove duplicatas de IDs de nota (caso 2 embarcadores tenham a mesma nota)
            const chavesUnicas = Array.from(new Set(invoicesKeys));

            // ==================================================================
            // Buscar Invoices (Também usando Chunking)
            // ==================================================================

            const chavesParaProcessar = [...chavesUnicas];
            const chunksDeChaves = chunkArray(chavesParaProcessar, 30);   // processando 30 de cada vez

            let todasAsNotas = [];

            await Promise.all(
                chunksDeChaves.map(async (lote) => {
                    const snapshot = await db
                        .collection("invoices")
                        .where("xmlId", "in", lote)
                        .get();

                    snapshot.forEach((doc) => {
                        // Reconstrói o objeto igual o Firebase faz
                        todasAsNotas.push({ id: doc.id, ...doc.data() });
                    });
                })
            );

            // Retorna um objeto que "imita" o snapshot do Firebase para o frontend não quebrar
            return {
                docs: todasAsNotas.map(nota => ({
                    id: nota.id,
                    data: () => nota // Função data() que o frontend espera
                })),
                forEach: (callback) => {
                    todasAsNotas.forEach((nota) => {
                        callback({
                            id: nota.id,
                            data: () => nota
                        });
                    });
                },
                empty: todasAsNotas.length === 0
            };

        } catch (error) {
            console.error("Erro no serviço de notas:", error);
            throw error;
        }
    },




/**
 * Busca os dados do shipper baseado no ID armazenado no Redux (users.uidShipper)
 * e atualiza o estado com os dados encontrados.
 * Se o shipper for encontrado, retorna o nome da empresa e o CNPJ.
 * Caso contrário, não realiza nenhuma ação.
 * @param {string} shipper o ID do shipper que ser  buscado
 * @returns Se o documento existir, ele retorna os dados do documento
 * @returns Se o documento n o existir, ele retorna null
 * @returns Se houver um erro, ele registra o erro no console
 */
    async findShipperByUser(shipper) {

        if (!shipper) return "Desconhecido 1";

        try {
            const db = firebase.firestore();
            const notasSnapshot = await db
                .collection("xml_document_nfe")
                .doc(shipper)
                .get();

            if (notasSnapshot.exists) {
                const data = notasSnapshot.data();

                const shipper = await db
                    .collection("shipper")
                    .doc(data.uidShipper)
                    .get();

                const fullShipper = shipper.data();

                console.log("fullShipper", fullShipper);

                return fullShipper ? fullShipper.dataPersonal.socialName : "Desconhecido 2";
            }
        } catch (error) {
            console.log("Erro no serviço de notas:", error);
        }



        // return shipperService.getShipperByUser(shipper);
    },
};
export default invoiceService;


function chunkArray(array, size) {
    const results = [];
    while (array.length) {
        results.push(array.splice(0, size));
    }
    return results;
}
